export const ADVISORS_QUERY = /* GraphQL */ `
  query GetAdvisors($instrument_id: String!, $search: String) {
    advisors: positions_for_instrument(
      instrument_id: $instrument_id
      search: $search
    ) {
      advisors {
        id
        name
        principal_value
        market_value
        gain_loss
        basis_market_value
        num_accounts
        accounts {
          id
          principal_value
          settled_principal_value
          market_value
          custodian_account_id
        }
      }
    }
  }
`

export const ACCOUNTS_QUERY = /* GraphQL */ `
  query GetAccounts(
    $instrument_id: String!
    $advisor_id: String!
    $search: String
  ) {
    accounts: positions_for_instrument_and_advisor(
      instrument_id: $instrument_id
      advisor_id: $advisor_id
      search: $search
    ) {
      accounts {
        id
        name
        principal_value
        settled_principal_value
        market_value
        gain_loss
        basis_market_value
        money_manager
        custodian_account_id
      }
    }
  }
`

export const POSITIONS_FOR_INSTRUMENT_QUERY = /* GraphQL */ `
  query PositionsForInstrument($instrument_id: String!) {
    positions_for_instrument(instrument_id: $instrument_id) {
      advisors {
        accounts {
          id
          name
          principal_value
          settled_principal_value
          market_value
          basis_market_value
          gain_loss
          money_manager
        }
        name
        num_accounts
        principal_value
        market_value
        basis_market_value
        gain_loss
      }
    }
  }
`
